export * from "./Home";
export * from "./Http404";
export * from "./Login";
export * from "./NovaConta";
export * from "./TrocarSenha";
export { AnexoFotoPage } from "./AnexoFoto";
export { MeusConteudosPage } from "./MeusConteudos";
export { MinhaContaPage } from "./MinhaConta";
export { NovoConteudoPage } from "./NovoConteudo";
